import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";
import { IFilterValue } from "../../../model/types";

type Props = {
  name: string;
  title: string;
  value: string | null; // "YYYY-MM"
  onChange: (v: IFilterValue<string | null>) => void;
};

const TableFilterMonth: FC<Props> = ({ name, title, value, onChange }) => {
  const pickerValue: Dayjs | null = value ? dayjs(`${value}-01`) : null;

  return (
    <Box sx={{ minWidth: 220 }}>
      <DatePicker
        views={["year", "month"]}
        openTo="month"
        label={title}
        value={pickerValue}
        onChange={(next) => {
          if (!next || !next.isValid()) {
            onChange({ name, value: null });

            return;
          }
          onChange({ name, value: next.format("YYYY-MM") });
        }}
        slotProps={{
          textField: {
            size: "small",
            InputLabelProps: { shrink: true },
          },
        }}
      />
    </Box>
  );
};

export default TableFilterMonth;
